import NewPassword from "./NewPassword";
import {useAppDispatch, useAppSelector} from "@hooks/redux-hooks/hooks";
import {logoutSuccess, selectUser} from "@commons/core.slice";
import React, {useState} from "react";
import FPNetLogo from "../../components/Logo";

const PasswordScaduta: React.FC = () => {
    const dispatch = useAppDispatch();
    const currentUser = useAppSelector(selectUser);
    const [done, setDone] = useState<boolean>(false);
    const onSuccess = () => {
        setDone(true);
    }
    return <>
        {!done &&
            <div className="h-full flex flex-col justify-center">
                <div className="">
                    <FPNetLogo className="mx-auto h-20 w-auto"/>
                    <NewPassword askEmail={false}
                                 title={() => {
                                     return <h3 className="text-blue-500"><p>Bentornato <span className="font-semibold">{currentUser!.nome}</span>, la tua password è scaduta!</p>
                                         Inserisci gentilmente una nuova password!</h3>;
                                 }}
                                 onSuccess={onSuccess}
                    />
                </div>
            </div>}
        {done &&
            <div className="h-full flex flex-col justify-center">
                <div className="">
                    <FPNetLogo className="mx-auto h-20 w-auto"/>
                    <div className="bg-white mt-2 sm:mx-auto sm:w-full sm:max-w-md">La password è stata aggiornata con successo.
                        Cliccare <a href="#" className="text-base text-indigo-600 hover:text-indigo-500"
                                    onClick={() => dispatch(logoutSuccess())}>quì</a> per effettuare l'accesso.
                    </div>
                </div>
            </div>
        }
    </>
}

export default PasswordScaduta;